<template>
    <div id="viewprofile">
        <div class="title black" id="profile">PROFILE</div>
        <div id="profileBox">
            <div>
                <img id="myphoto" src="../assets/photo/profile.jpg" alt="photo" />
                <div id="box"></div>
            </div>
            <div>
                <div id="nameBox">
                    <span>최소원</span>
                    <span>sowon choi</span>
                </div>
                <p>Web Backend Developer</p>
                <ul id="profileList">
                    <li>
                        <div>
                            <img src="../assets/icons/mail.png" alt="icon" />
                        </div>
                        <span>sowon901@naver.com</span>
                    </li>
                    <li>
                        <div>
                            <img src="../assets/icons/call.png" alt="icon" />
                        </div>
                        <span>010-5343-9039</span>
                    </li>
                    <li>
                                            </li>
                    <li>
                        <div>
                            <img src="../assets/icons/git.png" alt="icon" />
                        </div>
                        <span
                            ><a href="https://github.com/sowon901" target="_blank"
                                >github.com/sowon901</a
                            ></span
                        >
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {};
</script>
<style>
#myphoto {
    width: 280px;
}
.title {
    font-size: 3.6em;
}
#profile {
    color: #edb352;
    text-align: left;
}
#profileBox {
    margin-top: -24px;
}
#profileBox::after {
    content: "";
    display: block;
    clear: both;
}
#profileBox > div {
    float: left;
    padding-left: 100px;
    padding-top: 30px;
}
#profileBox > div:first-child {
    position: relative;
}
#profileBox > div:last-child {
    padding-top: 80px;
}
#box {
    border: 1px solid #12104e;
    width: 280px;
    height: 370px;
    position: absolute;
    top: -10px;
    left: 54px;
    z-index: -1;
}
#profileBox > div > p {
    background-color: #12104e;
    color: white;
    padding: 6px 10px;
    display: inline-block;
    margin: 10px 0;
}
#nameBox span:first-child {
    font-size: 1.8em;
    font-weight: 900;
}
#nameBox span:last-child {
    color: #727272;
    margin-left: 4px;
}
#profileList {
    list-style: none;
    padding: 0;
    margin: 20px 0 0;
}
#profileList > li {
    height: 52px;
}
#profileList::after {
    content: "";
    display: block;
    clear: both;
}
#profileList > li > div {
    float: left;
    height: 52px;
    line-height: 52px;
}
#profileList span {
    float: left;
    display: block;
    line-height: 52px;
}
#profileList img {
    width: 32px;
    vertical-align: middle;
    margin-right: 10px;
}
a {
    text-decoration: none;
    color: inherit;
}
</style>
